export const DEFAULT_CONFIGURATION_STATUS = 'ACTIVE';
export const DEFAULT_CONFIGURATION_MIMO = '4T4R';
